import { secondAxios } from "../../../../../api/axios";
import { getPlantMis } from "../../../../../api/misApi";
import {
  getMrqsForPlant,
  getPosForMrq,
} from "../../../AllEquipments/CommonFeatures/MCS3/Schedule4D/api";

// Runs one source so a failure is reported instead of thrown - the dashboard
// still shows whatever the other sources returned.
const settle = async (promise) => {
  try {
    return { ok: true, value: await promise };
  } catch (error) {
    console.error("5D dashboard source failed:", error);
    return { ok: false, value: null };
  }
};

/**
 * Everything procurement-side the dashboard needs for one plant, using the
 * same endpoints Schedule4D / MIS already call:
 *   GET /mrq/plant/:plantId     MRQs with mrqMaterials (wbs, procuredQty)
 *   GET /po/mrq/:mrqId          each MRQ's POs with poMaterials (cost)
 *   GET /payment/plant/:plantId payments (amount, po)
 *   GET /mis/plant/:plantId     customer invoices per discipline
 *
 * Resolves to { mrqs, posByMrqId, payments, mis, failed } where `failed` names
 * the sources that errored ("procurement" covers MRQs and their POs).
 */
export const fetchPlantProcurement = async (plantId) => {
  const [mrqRes, paymentRes, misRes] = await Promise.all([
    settle(getMrqsForPlant(plantId)),
    settle(
      secondAxios.get(`/payment/plant/${plantId}`).then((res) => res.data),
    ),
    settle(getPlantMis(plantId)),
  ]);

  const mrqs = Array.isArray(mrqRes.value) ? mrqRes.value : [];

  // One PO request per MRQ - the same fan-out Schedule4D does.
  const poResults = await Promise.all(
    mrqs.map((mrq) => settle(getPosForMrq(mrq.id))),
  );
  const posByMrqId = {};
  mrqs.forEach((mrq, i) => {
    posByMrqId[mrq.id] = Array.isArray(poResults[i].value)
      ? poResults[i].value
      : [];
  });

  const failed = [];
  if (!mrqRes.ok || poResults.some((res) => !res.ok)) failed.push("procurement");
  if (!paymentRes.ok) failed.push("payments");
  if (!misRes.ok) failed.push("invoices");

  return {
    mrqs,
    posByMrqId,
    payments: Array.isArray(paymentRes.value) ? paymentRes.value : [],
    // getPlantMis resolves null when the plant has no MIS record yet - that is
    // "no invoices", not a failure.
    mis: misRes.value,
    paymentsLoaded: paymentRes.ok,
    failed,
  };
};
